import {styled} from "@mui/system";

const MainMenuPictogram = styled('div')({
    marginLeft: '-0.375rem',
    display: 'flex',
    alignItems: 'center',
});

export default MainMenuPictogram;